import { render, staticRenderFns } from "./approve-resolve.vue?vue&type=template&id=11e60acc&scoped=true&"
import script from "./approve-resolve.vue?vue&type=script&lang=js&"
export * from "./approve-resolve.vue?vue&type=script&lang=js&"
import style0 from "./approve-resolve.vue?vue&type=style&index=0&id=11e60acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e60acc",
  null
  
)

export default component.exports